import React from "react";
import '@lottiefiles/lottie-player';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlay } from '@fortawesome/free-solid-svg-icons';
import { faPause } from '@fortawesome/free-solid-svg-icons';
import * as palette from "../Variables";
import styled from "styled-components";

const AnimationButton = styled.button`
  border: none;
  background-color: transparent;
  cursor: pointer;
  color: ${palette.neutral11};
  display: flex;
  align-items: center;
  height: 24px;
  margin-top: 12px;
  padding-left: 4px;
  padding-right: 4px;
  transition: color 0.2s, background 0.2s;

  &:hover {
    color: ${palette.pinkMain};
    text-decoration: underline;
    text-underline-offset: 4px;
  }

  &:focus-visible {
    color: ${palette.pinkMain};
    outline: 3px solid ${palette.blueMain};
    outline-offset: 4px;
    border-radius: 4px;
    text-decoration: underline;
    text-underline-offset: 4px;
  }
`;

class App extends React.Component {
  constructor(props) {
    super(props);
    this.myRef = React.createRef();
    this.state = { isPaused: false };
  }

  handleToggle = () => {
    const player = this.myRef.current;
    if (!player) return;
    if (this.state.isPaused) {
      player.play();
      player.setAttribute("autoplay", "true");
      this.setState({ isPaused: false });
    } else {
      player.pause();
      player.setAttribute("autoplay", "false");
      this.setState({ isPaused: true });
    }
  };

  componentDidMount() {
    // Start playing on mount
    const player = this.myRef.current;
    if (player) {
      player.play();
      player.setAttribute("autoplay", "true");
    }
  }

  render() {
    return (
      <div className="App" style={{ display: "flex", flexDirection: "column", alignItems: "flex-end" }}>
        <lottie-player
          ref={this.myRef}
          id="firstLottie"
          mode="normal"
          loop="true"
          src="https://lottie.host/d69dd55b-4ed4-48f0-a7f1-71e4f05ef09e/EN79RKmg3A.json"
          aria-label="Three illustrations of Courtney standing around a wireframe. One Courtney is holding a stack of swatches matching the colors of the illustration and the rest of the website, one Courtney is holding a text box, and one Courtney is holding a ruler. The stack of swatches opens and closes, a wrench next to the wireframe wiggles, and text is typed out into the wireframe."
        ></lottie-player>
        <AnimationButton
          onClick={this.handleToggle}
          aria-label="Toggle animation pause/play">
          <span style={{ marginRight: "6px" }}>{this.state.isPaused ? <FontAwesomeIcon icon={faPlay} style={{fontSize: 16}}></FontAwesomeIcon> : <FontAwesomeIcon icon={faPause} style={{fontSize: 16}}></FontAwesomeIcon>}</span>
          <span style={{fontSize: 14}}>{this.state.isPaused ? "Play animation" : "Pause animation"}</span>
        </AnimationButton>
      </div>
    );
  }
}

export default App;